import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

type IdentityStatusType =
  | 'APPROVED'
  | 'OCR_WRONG_DOCUMENT'
  | 'OCR_IN_PROGRESS'
  | 'BANKID_IN_PROGRESS'
  | 'OCR_MANUAL_CHECK_NEEDED'
  | 'BANKID_ERROR'
  | 'BANKID_DATA_MISMATCH'
  | 'BANKID_REJECTED_BY_CLIENT'
  | 'BANKID_REJECTED'
  | 'REQUESTED'
  | 'BANKID_NATIONALITY_BLACKLISTED'
  | 'BANKID_FOREIGNER_NOT_ALLOWED';

type BankAccountStatusType =
  | 'APPROVED_WITH_INCOME'
  | 'APPROVED'
  | 'PSD2_PAYMENT_SENT_WITH_INCOME'
  | 'PSD2_PAYMENT_SENT'
  | 'PSD2_PAYMENT_INITIATED'
  | 'PSD2_PAYMENT_ERROR'
  | 'PSD2_NAME_SURNAME_MISMATCH'
  | 'BANKID_IN_PROGRESS'
  | 'REQUESTED';

export type IdentificationStatusResponseBody = {
  identityStatus: IdentityStatusType;
  bankAccountStatus: BankAccountStatusType;
};

export default function useClientIdentificationStatusQuery() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<IdentificationStatusResponseBody>({
    queryKey: ['client', 'identification-status'],
    queryFn: async () => {
      try {
        const response = await fetchData('/client/identification-status');

        return response;
      } catch (e) {
        error(
          '[useClientIdentificationStatusQuery][GET /client/identification-status]',
          e,
        );
        showError();
        throw e;
      }
    },
  });
}
